import { Box, styled } from "@mui/material";

import theme from "fond/theme";

export const InboxContainer = styled(Box)`
  /* Novu customisations */
  & .novu {
    .nv-notification {
      &:hover {
        background-color: ${theme.palette.biarri.secondary.whiteSmoke};
      }
    }

    .nv-notificationPrimaryAction__button {
      /* Duplicate Mui Button styling */
      display: inline-flex;
      background: ${theme.palette.primary.main};
      border-radius: ${theme.shape.borderRadius}px;
      box-shadow: ${theme.shadows[1]};
      line-height: 1.75;
      letter-spacing: 0.02857em;
      height: auto;
      transition:
        background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
        box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
        border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
        color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
      padding: ${theme.spacing(0.5, 2)};

      &:hover,
      &:focus-visible {
        background-color: ${theme.palette.primary.dark};
        box-shadow: ${theme.shadows[2]};
      }
    }
    .nv-notificationListContainer + div:last-child {
      display: none;
    }
    /* Remove extra padding reserved for the footer that we're hiding */
    .nv-notificationList {
      padding-bottom: 0;
    }

    /* Novu renders an extra div around the channel icons when they are custom icons */
    .nv-channelIconContainer > div {
      line-height: 0;
    }

    .nv-notificationCustomActions {
      margin-left: auto;
      margin-top: ${theme.spacing(1)};
    }
  }
`;
